module.exports = __webpack_public_path__ + "static/oxaco-logo-f6c97ea14838f28dc398e967b30f909b.svg";